import React from "react";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { useI18n } from "@/i18n/I18nContext";

import { WIZARD } from "@/constants/testIds";

const DURATIONS = [2, 3, 4];
const VERSIONS = [1, 2, 3];

export default function Step2DurationLyrics({ form, update, pricingConfig }) {
  const { t, language } = useI18n();
  const durationPrices = pricingConfig?.duration_prices || {};
  const versionsFee = pricingConfig?.versions_fee || {};
  return (
    <div className="space-y-8">
      <div>
        <Label className="text-base">{t("wizard.durationLabel")}</Label>
        <div className="mt-3 grid grid-cols-3 gap-2">
          {DURATIONS.map((d) => (
            <button
              key={d}
              type="button"
              data-testid={WIZARD.durationOption(d)}
              onClick={() => update({ duration_minutes: d })}
              className={`rounded-xl border px-2 py-4 text-center transition-all ${
                form.duration_minutes === d ? "border-primary bg-primary/10 text-primary" : "border-border hover:border-primary/40"
              }`}
            >
              <p className="font-heading text-lg font-semibold">{d} min</p>
              
            </button>
          ))}
        </div>
      </div>

      <div>
        <Label className="text-base">{t("wizard.versionsLabel")}</Label>
        <p className="mt-1 text-sm text-muted-foreground">{t("wizard.versionsDesc")}</p>
        <div className="mt-3 grid grid-cols-3 gap-2">
          {VERSIONS.map((v) => (
            <button
              key={v}
              type="button"
              data-testid={WIZARD.versionsOption(v)}
              onClick={() => update({ num_versions: v })}
              className={`rounded-xl border px-3 py-4 text-center transition-all ${
                form.num_versions === v ? "border-primary bg-primary/10 text-primary" : "border-border hover:border-primary/40"
              }`}
            >
              <p className="font-heading text-lg font-semibold">{v}</p>
              <p className="text-xs text-muted-foreground">
              </p>
            </button>
          ))}
        </div>
      </div>

      <div>
        <Label className="text-base">{t("wizard.lyricsModeLabel")}</Label>
        <div className="mt-3 grid grid-cols-1 gap-3 sm:grid-cols-2">
          <button
            type="button"
            data-testid={WIZARD.lyricsModeAuto}
            onClick={() => update({ lyrics_mode: "auto" })}
            className={`rounded-xl border p-4 text-left transition-all ${
              form.lyrics_mode === "auto" ? "border-primary bg-primary/10" : "border-border hover:border-primary/40"
            }`}
          >
            <p className="font-medium">{t("wizard.lyricsAuto")}</p>
          </button>
          <button
            type="button"
            data-testid={WIZARD.lyricsModeCustom}
            onClick={() => update({ lyrics_mode: "custom" })}
            className={`rounded-xl border p-4 text-left transition-all ${
              form.lyrics_mode === "custom" ? "border-primary bg-primary/10" : "border-border hover:border-primary/40"
            }`}
          >
            <p className="font-medium">{t("wizard.lyricsCustom")}</p>
          </button>
        </div>
        {form.lyrics_mode === "custom" && (
          <Textarea
            data-testid={WIZARD.customLyricsInput}
            placeholder={t("wizard.customLyricsPlaceholder")}
            value={form.custom_lyrics}
            onChange={(e) => update({ custom_lyrics: e.target.value })}
            className="mt-3 min-h-40 rounded-xl"
          />
        )}
      </div>
    </div>
  );
}
